import Moment from 'moment'

export default class claimedRewardDateCheck {
  static isAnyDateExpired(dates) {
    const [couponExpiresAt, distributionExpiresAt, dlistExpiresAt] = dates
    const today = Moment(new Date())

    if (couponExpiresAt) {
      if (Moment(couponExpiresAt).isBefore(today)) return true
    } else if (dlistExpiresAt) {
      if (Moment(dlistExpiresAt).isBefore(today)) return true
    } else if (distributionExpiresAt) {
      if (Moment(distributionExpiresAt).isBefore(today)) return true
    }
    return false
  }
}
